// @ts-nocheck
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from 'appRedux/actions/file_manager';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import getQueryParams from 'utils/getQueryParams';

function* getAssetsRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/file-manager/?${query}`,
    token,
  );

  if (data) {
    yield put({
      type: types.GET_ASSETS_SUCCESS,
      payload: data,
    });
  }
}

function* getAssetByIdRequest(action) {
  const token = localStorage.getItem('token');
  const {
    payload: { folderId, projectId },
  } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/file-manager/${folderId}/?project_id=${projectId}`,
    token,
  );

  if (data) {
    yield put({
      type: types.GET_ASSET_BY_ID_SUCCESS,
      payload: data,
    });
  }
}

function* addAssetsRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.postFormData,
    `${API_URI}/file-manager/`,
    'post',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_FORM_MODAL });
    yield put({ type: types.ADD_ASSETS_SUCCESS, payload: data });
  }
}

function* deleteAssetRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/file-manager/${payload.id}/`,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
    yield put({
      type: types.DELETE_ASSET_SUCCESS,
      payload,
    });
  }
}

function* updateAssetRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const {
    payload: { id, ...rest },
  } = action;
  const data = yield call(
    services.postFormData,
    `${API_URI}/file-manager/${id}/`,
    'put',
    rest,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_FORM_MODAL });
    yield put({
      type: types.UPDATE_ASSET_SUCCESS,
      payload: data,
    });
  }
}

function* getTagsRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/file-tag/?${query}`,
    token,
  );

  if (data) {
    yield put({
      type: types.GET_TAGS_SUCCESS,
      payload: data,
    });
  }
}

function* fileManagerWatcher() {
  yield takeLatest(types.GET_ASSETS_REQUEST, getAssetsRequest);
  yield takeLatest(types.GET_ASSET_BY_ID_REQUEST, getAssetByIdRequest);
  yield takeLatest(types.ADD_ASSETS_REQUEST, addAssetsRequest);
  yield takeLatest(types.DELETE_ASSET_REQUEST, deleteAssetRequest);
  yield takeLatest(types.UPDATE_ASSET_REQUEST, updateAssetRequest);
  yield takeLatest(types.GET_TAGS_REQUEST, getTagsRequest);
}

export default fileManagerWatcher;
